import { type TextareaHTMLAttributes, forwardRef } from 'react'

import { cn } from '@/lib/utils'

/**
 * Multi-line counterpart to `<Input>`. Same border / focus rules,
 * resizable vertically, defaults to 3 rows.
 */
export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className, invalid = false, rows = 3, ...props }, ref) {
    return (
      <textarea
        ref={ref}
        rows={rows}
        className={cn(
          'min-h-[5rem] w-full rounded-md border bg-surface px-3 py-2 text-sm text-text',
          'placeholder:text-text-muted',
          'transition-colors duration-100',
          'resize-y',
          'focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand',
          'disabled:cursor-not-allowed disabled:opacity-60',
          invalid
            ? 'border-danger focus:border-danger focus:ring-danger'
            : 'border-surface-border',
          className,
        )}
        {...props}
      />
    )
  },
)
